import { memo, useEffect } from "react";
import { useSetRecoilState } from "recoil";
import { cloudConfigStatusState } from "@/store/atoms";

export default memo(function CloudConfigInitializer() {
  const setStatus = useSetRecoilState(cloudConfigStatusState);
  useEffect(() => {
    const json = sessionStorage.getItem("cloud_config_status");
    if (json) {
      try {
        setStatus(JSON.parse(json));
      } catch (e) {
        console.error(e);
      }
    }
  }, [setStatus]);
  return null;
});
